import type { ProductModifierGroup } from "./productModifiers"

import { api } from "@/api"
import type { Ref } from "vue"
import { useQuery } from "@tanstack/vue-query"

const listProductModifierGroups = async (): Promise<
  ProductModifierGroup[]
> => {
  const response = await api.get<ProductModifierGroup[]>(
    "/products/product-modifiers/"
  )

  return response.body
}

export const useProductModifierGroups = () => {
  const queryReturn = useQuery({
    queryKey: [BASE_PRODUCT_MODIFIERS_QUERY_KEY],
    queryFn: () => listProductModifierGroups(),
    staleTime: 60 * 60 * 1000,
  })
  const getById = (
    id: string | undefined | Ref<string | undefined>
  ) =>
    computed(() =>
      unref(id)
        ? queryReturn.data.value?.find(
            (productModifierGroup) =>
              productModifierGroup.id === unref(id)
          )
        : undefined
    )

  return {
    ...queryReturn,
    getById,
  }
}
